import React from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

export default function MessageDialog({
  open,
  title,
  message,
  severity = "error",
  confirmLabel = "OK",
  onClose,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableRestoreFocus
      maxWidth="xs"
      fullWidth
      slotProps={{
        paper: {
          sx: {
            borderRadius: 2,
            overflow: "hidden",
            boxShadow: 24,
          },
        },
      }}
    >
      <DialogTitle sx={{ fontSize: 18, fontWeight: 700, color: "#004f7d", pb: 0.5 }}>
        {title}
      </DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        <Alert severity={severity} sx={{ fontSize: 13 }}>
          {message}
        </Alert>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.25, pt: 0.75 }}>
        <Button
          autoFocus
          variant="contained"
          onClick={onClose}
          sx={{
            textTransform: "none",
            minWidth: 110,
            backgroundColor: "#004f7d",
            "&:hover": {
              backgroundColor: "#03608f",
            },
          }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
